import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';

    public data: any = {
        email: '',
        password: ''
    };

    public demoAccounts: any[] = [
        {
            name: '관리자',
            email: 'admin@kiosk.local',
            password: 'admin1234',
            role: 'admin',
            roleLabel: '관리',
            badgeClass: 'bg-indigo-50 text-indigo-700'
        },
        {
            name: '도서 담당자',
            email: 'library@kiosk.local',
            password: 'library1234',
            role: 'user',
            roleLabel: '도서',
            badgeClass: 'bg-sky-50 text-sky-700'
        },
        {
            name: '방문 담당자',
            email: 'visit@kiosk.local',
            password: 'visit1234',
            role: 'user',
            roleLabel: '방문',
            badgeClass: 'bg-emerald-50 text-emerald-700'
        },
        {
            name: '회의실 담당자',
            email: 'meeting@kiosk.local',
            password: 'meeting1234',
            role: 'user',
            roleLabel: '회의실',
            badgeClass: 'bg-amber-50 text-amber-700'
        }
    ];

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/";
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public selectDemoAccount(account: any) {
        this.data.email = account.email;
        this.data.password = account.password;
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        // user.password = this.service.auth.hash(user.password);

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            location.href = "/";
            await this.service.render();
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        }
    }
}

export default PageAccessComponent;